import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import config from './config.json';

const StepFinal = () => {

  return (
    <Container className="py-5">
      <Row>
        <Col className="text-center">
          <i className='bi bi-check-circle display-1 text-success'></i>
          <h2>{config.stepFinal.title}</h2>
          <p>{config.stepFinal.description}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default StepFinal;
